<!--
 * @Author: cn1994
 * @Date: 2023-09-07 10:21:10
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-12 14:02:54
 * @Description: file content
-->
<template>
  <div class="ls-mobile-preview-phone-component">
    <div class="panel">
      <div class="top">
        <div class="left">
          <div class="subject-cell">
            <span class="subject">{{ instInfo.subject }}</span>
            <div class="icon flex items-center justify-center">
              <i class="el-icon-sort"></i>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="cell-item message-cell">
            <img class="icon" src="https://cdnws.51tyty.com/lstyty/file/2024/05/22/e6def255b2f795d053e18a69595ec5c5.png" alt="">
            <span>消息</span>
          </div>
          <div class="cell-item setting-cel ml-[10px]">
            <img class="icon" src="https://cdnws.51tyty.com/lstyty/file/2024/05/22/c81cc399c127a5f1b0f4b379f55796ba.png" alt="">
            <span>设置</span>
          </div>
        </div>
      </div>
      <div class="bottom" @mousewheel="handelMousewheel">
        <plateComponent :plateConfig="plateConfig" :role="role" />
      </div>
    </div>
  </div>
</template>

<script>
import plateComponent from './plate.vue'

export default {
  components: {
    plateComponent
  },
  props: {
    instInfo: {
      type: Object,
    },
    role: {
      type: String,
    },
    plateConfig: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentTab: {
      type: String,
    }
  },
  data() {
    return  {
    }
  },
  methods: {
    handelMousewheel(e) {
      let dom = document.querySelector('.bottom')
      let ua = window.navigator.userAgent
      let isMac = ua.includes('OS X')
      if (isMac) {
        if (e.deltaX > 0) {
          // 往左划
          dom.scrollLeft += 20
        } else {
          // 往右划
          dom.scrollLeft -= 20
        }
      } else {
        if (e.deltaY > 0) {
          // 往左划
          dom.scrollLeft += 100
        } else {
          // 往右划
          dom.scrollLeft -= 100
        }
      }
      
      e.preventDefault()
    },
  }
}
</script>

<style lang="less" scoped>
.ls-mobile-preview-phone-component {
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(5px);

  .panel {
    flex:1;
    display: flex;
    flex-direction: column;
    .top {
      height: 50px;
      max-width: 750px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px 0 16px;
      .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        
        .subject-cell {
          background-color: rgba(32,30,67,0.1);
          height: 26px;
          border-radius: 13px;
          padding: 5px 7px 5px 11px;
          display: flex;
          flex-direction: row;
          align-items: center;
          width: fit-content;
          .subject {
            font-size: 12px;
            color: #fff;
          }
          .icon {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            background-color: rgba(46, 129, 255, 1);
            border-radius: 50%;
            color: #fff;
            font-weight: 600;
            font-size: 8px;
            transform: rotate(90deg);
          }
        }
      }
      
      
      .right {
        display: flex;
        flex-direction: row;
        align-items: center;
        
        .cell-item {
          background-color: rgba(32,30,67,0.1);
          height: 26px;
          border-radius: 13px;
          padding: 5px 7px 5px 11px;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 5px 9px;
          font-size: 12px;
          color: #fff;
          .icon {
            width: 12px;
            height: 12px;
            margin-right: 3px;
          }
        }
      }
    }
    .bottom {
      flex: 1;
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      overflow-x: scroll;
      .more {
        width: 15px;
        height: 78px;
        background-color: rgba(32, 30, 67, 0.1);
        color: #fff;
        font-weight: 600;
        border-radius: 0px 50px 50px 0px;
      }
    }
  }
}
</style>
